import appAxios from "./axios";

class UsersService {
  me = async () => {
    return await appAxios.get("/user");
  };
  deleteAccount = async () => {
    return await appAxios.post("/app/user/delete-account");
  };
  registerDeviceTokenForPushNotifications = async (deviceToken) => {
    return await appAxios.put("/app/user/device-token", { deviceToken });
  }
}

const usersService = new UsersService();
export default usersService;
